<div class="show-avatar" [class]="size">
  @if (hasImage) {
    <img [src]="fullImageUrl" [alt]="showName" class="avatar-image" />
  }
  @if (!hasImage) {
    <div
      class="avatar-initials"
      [style.background-color]="avatarStyle.backgroundColor"
      [style.color]="avatarStyle.textColor">
      {{ avatarStyle.initials }}
    </div>
  }
</div>
